import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebase/config"; // Import Firebase
import { doc, updateDoc, getDoc, arrayUnion, arrayRemove } from "firebase/firestore";


// export const fetchFavorites = createAsyncThunk(
//   "favorites/fetchFavorites",
//   async (userId) => {
//     const userRef = doc(db, "users", userId);
//     const userDoc = await getDoc(userRef);
//     return userDoc.exists() ? userDoc.data().favourite_products || [] : [];
//   }
// );


// export const toggleFavoriteInFirestore = createAsyncThunk(
//   "favorites/toggleFavoriteInFirestore",
//   async ({ userId, productId, isFavorite }, { rejectWithValue }) => {
//     try {
//       const userRef = doc(db, "users", userId);
//       await updateDoc(userRef, {
//         favourite_products: isFavorite ? arrayRemove(productId) : arrayUnion(productId),
//       });
//       return productId;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const favoritesSlice = createSlice({
//   name: "favorites",
//   initialState: {
//     favoriteProducts: [],
//     status: "idle",
//   },
//   reducers: {
//     toggleFavoriteLocal: (state, action) => {
//       const productId = action.payload;
//       if (state.favoriteProducts.includes(productId)) {
//         state.favoriteProducts = state.favoriteProducts.filter((id) => id !== productId);
//       } else {
//         state.favoriteProducts.push(productId);
//       }
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchFavorites.fulfilled, (state, action) => {
//         state.favoriteProducts = action.payload;
//       })
//       .addCase(toggleFavoriteInFirestore.fulfilled, (state, action) => {
       
//       });
//   },
// });

// export const { toggleFavoriteLocal,setFavorites } = favoritesSlice.actions;
// export default favoritesSlice.reducer;


// export const toggleFavoriteInFirestore = createAsyncThunk(
//     "favorites/toggleFavoriteInFirestore",
//     async ({ userId, productId, isFavorite }, { dispatch, rejectWithValue }) => {
//       try {
//         const userRef = doc(db, "users", userId);
//         await updateDoc(userRef, {
//           favourite_products: isFavorite ? arrayRemove(productId) : arrayUnion(productId),
//         });
  
//         dispatch(setFavoritesAfterToggle({ productId, isFavorite }));
//       } catch (error) {
//         return rejectWithValue(error.message);
//       }
//     }
//   );
  
//   const favoritesSlice = createSlice({
//     name: "favorites",
//     initialState: {
//       favoriteProducts: [],
//     },
//     reducers: {
//       setFavorites: (state, action) => {
//         state.favoriteProducts = action.payload;
//       },
//       setFavoritesAfterToggle: (state, action) => {
//         const { productId, isFavorite } = action.payload;
//         state.favoriteProducts = isFavorite
//           ? state.favoriteProducts.filter((id) => id !== productId)
//           : [...state.favoriteProducts, productId];
//       },
//     },
//   });
  
//   export const { setFavorites, setFavoritesAfterToggle } = favoritesSlice.actions;
//   export default favoritesSlice.reducer;

export const toggleFavoriteInFirestore = createAsyncThunk(
  "favorites/toggleFavoriteInFirestore",
  async ({ userId, productId, isFavorite }, { rejectWithValue }) => {
    try {
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, {
        favourite_products: isFavorite ? arrayRemove(productId) : arrayUnion(productId),
      });
      return productId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const favoritesSlice = createSlice({
  name: "favorites",
  initialState: {
    favoriteProducts: [],
    status: "idle",
  },
  reducers: {
    toggleFavoriteLocal: (state, action) => {
      const productId = action.payload;
      if (state.favoriteProducts.includes(productId)) {
        state.favoriteProducts = state.favoriteProducts.filter((id) => id !== productId);
      } else {
        state.favoriteProducts.push(productId);
      }
    },
    setFavorites: (state, action) => {
      state.favoriteProducts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toggleFavoriteInFirestore.fulfilled, (state, action) => {
      // No need to update state, as it's already updated locally
    });
  },
});

export const { toggleFavoriteLocal, setFavorites } = favoritesSlice.actions;
export default favoritesSlice.reducer;